module.exports = __webpack_public_path__ + "static/media/dst-icon-white.97d1f032.svg";